import { FONT_SIZE_MEDIUM } from '~/Constants/UI.constants';
import { VERTICAL_SEPARATOR } from '../../../../Constants/Colors.constants';
import { makeStyles } from '~/UIKit/Style';

export const EventPageInformationStyles = makeStyles((theme) => ({
  header: {
    overflow: 'hidden',
    position: 'relative',
    fontSize: 16,
    border: `thin solid ${VERTICAL_SEPARATOR}`,
    paddingBottom: 30,
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  infoWrapper: {
    padding: 15,
  },
  EventPageInformationTitle: {
    fontSize: FONT_SIZE_MEDIUM,
    lineHeight: '20px',
    display: 'flex',
    alignItems: 'flex-end',
    marginBottom: 15,
  },
  EventPageInformationTitleText: {
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },
}));
